import { Route, Routes } from 'react-router-dom';
import { useEffect } from 'react';

import { StoreContext } from '@/contexts/StoreContext';

import RootStore from '@/stores/RootStore';

import PopularKeyword from '@/pages/PopularKeyword';
import ErrorReportStore from '@/stores/ErrorReportStore';

const ROOT = '/MW/search/popularKeyword';
const rootPath = process.env.NODE_ENV === 'development' ? '/' : ROOT;

const App = () => {
  useEffect(() => {
    ErrorReportStore.flush();
  }, []);

  return (
    <StoreContext.Provider value={new RootStore()}>
      <Routes>
        <Route path={rootPath} element={<PopularKeyword />} />
      </Routes>
    </StoreContext.Provider>
  );
};

export default App;
